// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"134":"perfis","234":"Feriados","264":"tiposderefeicoes","327":"configuracoes","404":"usuarios","890":"refeicoes"}[chunkId] || chunkId) + "." + {"99":"fe12a068","134":"1897d6e6","234":"44732582","264":"d38a189f","327":"578c7eee","354":"38ef20c8","404":"6d8637ad","838":"77eed58f","890":"cda4ac1e"}[chunkId] + ".js";
};